
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import {extend} from './../../zviz2/zviz/functions';
import SimpleEvent from './../../zviz2/zviz/event';
import config from './../../config';
import {styleText} from './../../styles';
import {scrollY, scrollX} from './../../tools';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.shown = false;
        this.text = '';
        this.event = null;
        this.mousePos = [0,0];
        this.textAlign = 'left';

        this.canvas = null;

    }

    init(renderer){
        this.canvas = renderer.rootController.renderOutput.result;
        
        super.init(renderer);

        this.event = null; // init() removes the event
        this.shown = false;
    }

    render(renderer){
        super.render(renderer);
        if(this.shown){
            this.update();
        }
    }

    showTooltip(){
        this.text = state.get('tooltip');

        if(! this.text){
            this.hideTooltip();
        }else{
            if(this.text instanceof Array){
                this.text = this.text.join(' - ');
            }
            this.shown = true;
            this.event = new SimpleEvent(document, 'mousemove', [this, this.positionTooltip]);
            this.addEvent(this.event);
            this.update();
        }
    }

    hideTooltip(){
        if(this.event){
            this.removeEvent(this.event);
            this.event = false;
            this.shown = false;
        }
        this.update();
    }

    positionTooltip(event){
        this.mousePos = [event.pageX, event.pageY];
        this.update();
    }

    getTop(){

        let offset = 0;
        let sT = scrollY();
        if(this.canvas){
            offset = this.canvas.getBoundingClientRect().top;
        }
        let height = this.renderOutput.result.clientHeight;

        return Math.max(0, this.mousePos[1] - sT - offset - 0.5*height);
    }

    getTextAlign(){
        let margin = (state.get('renderSize')=='small')? 150: 350;
        if(this.mousePos[0] > (window.innerWidth - margin) ){
            this.textAlign = 'right';
        }else{
            this.textAlign = 'left';
        }

        return this.textAlign;
    }

    getLeft(){

        let offset = 0;
        let margin = (state.get('renderSize')=='small')? 150: 350;
        if(this.mousePos[0] > (window.innerWidth - margin) ){
            return 'auto'; //this.mousePos[0] - (margin-25);
        }else{
            if(this.canvas){
                offset = this.canvas.getBoundingClientRect().left;
            }
             let sL = scrollX();
            return (this.mousePos[0] + 25 - sL - offset) + 'px';
        }
    }

    getRight(){
        let margin = (state.get('renderSize')=='small')? 150: 350;
        let offset = window.innerWidth;
        if(this.mousePos[0] > (window.innerWidth - margin) ){
            if(this.canvas){
                offset = this.canvas.getBoundingClientRect().right;
            }
            let sL = scrollX();
            return (offset - this.mousePos[0] + 25 + sL ) + 'px';
        }else{
            return 'auto'
        }
    }



}


let Blueprint = {
    type: Controller,
    properties: {
        style: extend({ 
            position: 'absolute',
            display: (ctrl) => ( ctrl.shown? 'block': 'none'),
            backgroundColor: 'rgba(255,255,255,0.7)',
            width: '280px',
            padding: '10px',
            border: '1px solid #999',
            textAlign: (ctrl) => ( ctrl.getTextAlign() ),
            top: (ctrl) => ( ctrl.getTop() + 'px' ),
            left: (ctrl) => ( ctrl.getLeft() ),
            right: (ctrl) => ( ctrl.getRight() ),
            zIndex: 5
        }, styleText),
        content: (ctrl) => ( ctrl.text ),
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.showTooltip], 'tooltip')),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.hideTooltip], 'filter')),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.hideTooltip], 'view')),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.hideTooltip], 'source')),
    ]
};


export default Blueprint;
export {Controller};
